import { Group, Quaternion, Vector3 } from 'three';

/** Out past where hands rest, so a controller isn't already in the panel. */
export const MENU_DIST_CONTROLLERS = 1.05;
/** Within arm's reach, so fingers can press the buttons. */
export const MENU_DIST_HANDS = .45;

/** Inputs are XR reference-space poses; the menu is a child of XROrigin. */
export class VRMenuAnchor {
  private yaw = 0;
  private initialized = false;
  private turning = false;
  private forward = new Vector3();

  update(menu: Group, head: Vector3, orientation: Quaternion, delta: number, recenter = false, distance = MENU_DIST_CONTROLLERS) {
    this.forward.set(0, 0, -1).applyQuaternion(orientation);
    const heading = this.forward.x ** 2 + this.forward.z ** 2 > .01
      ? Math.atan2(-this.forward.x, -this.forward.z) : this.yaw;
    let difference = Math.atan2(Math.sin(heading - this.yaw), Math.cos(heading - this.yaw));
    if (!this.initialized || recenter) {
      this.yaw = heading;
      this.initialized = true;
      this.turning = false;
    } else {
      if (Math.abs(difference) > Math.PI / 5) this.turning = true;
      if (this.turning) {
        this.yaw += difference * (1 - Math.exp(-8 * Math.min(delta, .1)));
        if (Math.abs(difference) < .01) this.turning = false;
      }
    }
    // Translation is immediate: walking and teleporting cannot leave the menu behind.
    // Ignore pitch/roll so looking down does not push the controls away.
    menu.position.set(head.x - Math.sin(this.yaw) * distance, head.y - .28, head.z - Math.cos(this.yaw) * distance);
    menu.rotation.set(-.25, this.yaw, 0, 'YXZ');
  }
}
